export const segment = (value) => encodeURIComponent(value);

export const joinPath = (base, ...segments) => {
  const normalizedBase = String(base || '').replace(/\/+$/, '');
  const suffix = segments
    .filter((value) => value !== undefined && value !== null && value !== '')
    .map((value) => segment(value))
    .join('/');
  return suffix ? `${normalizedBase}/${suffix}` : normalizedBase;
};

export const filterParams = (params = {}, { omitEmptyString = true } = {}) =>
  Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => (
      value !== undefined &&
      value !== null &&
      (!omitEmptyString || value !== '')
    )),
  );

export const withQuery = (path, params = {}, options = {}) => {
  const filtered = filterParams(params, options);
  const query = new URLSearchParams(filtered).toString();
  return query ? `${path}?${query}` : path;
};
